import { AlertTriangle, Pencil, Plus, Truck } from 'lucide-react';
import ExpiryBadge from './ExpiryBadge';
import { daysUntil } from './complianceUtils';

function StatusBadge({ status }) {
  const colors = {
    Available: 'bg-emerald-50 text-emerald-700 ring-emerald-500/25',
    Engaged: 'bg-logi-accent/10 text-logi-accent ring-logi-accent/30',
    Maintenance: 'bg-amber-50 text-amber-700 ring-amber-500/25',
  };
  return (
    <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold uppercase ring-1 ${colors[status] || colors.Available}`}>
      {status}
    </span>
  );
}

export default function MoverRegistryPanel({ movers, onAdd, onEdit }) {
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <Truck className="h-4 w-4 text-logi-accent" />
          <h3 className="text-sm font-bold text-logi-text">Movers Registry ({movers.length})</h3>
        </div>
        <button type="button" onClick={onAdd} className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-r from-white0 to-blue-400 px-4 py-2.5 text-sm font-bold text-white shadow-lg shadow-blue-500/20">
          <Plus className="h-4 w-4" />
          Add New Mover Head
        </button>
      </div>

      <div className="overflow-hidden rounded-xl border border-logi-grid bg-white">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[880px] text-left text-sm">
            <thead>
              <tr className="border-b border-logi-grid/80 bg-white text-[10px] uppercase tracking-wider text-logi-text0">
                <th className="px-3 py-2.5 font-semibold">Mover</th>
                <th className="px-3 py-2.5 font-semibold">Chassis / Engine</th>
                <th className="px-3 py-2.5 font-semibold">Mulkiya</th>
                <th className="px-3 py-2.5 font-semibold">Insurance</th>
                <th className="px-3 py-2.5 font-semibold">Dashcam</th>
                <th className="px-3 py-2.5 font-semibold">Status</th>
                <th className="px-3 py-2.5 font-semibold">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-logi-grid/30">
              {movers.map((m) => {
                const mulkiyaAlert = daysUntil(m.mulkiyaExpiry) <= 30;
                return (
                  <tr key={m.id} className="hover:bg-logi-silver">
                    <td className="px-3 py-2.5">
                      <div className="flex items-center gap-2">
                        {m.moverPhoto?.previewUrl ? (
                          <img src={m.moverPhoto.previewUrl} alt="" className="h-8 w-8 rounded-md object-cover ring-1 ring-logi-grid" />
                        ) : (
                          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-white text-logi-text0"><Truck className="h-4 w-4" /></span>
                        )}
                        <div>
                          <p className="font-semibold text-logi-accent">{m.plateNumber}</p>
                          {m.makeModel && (
                            <p className="text-[10px] text-logi-text0">{m.makeModel}</p>
                          )}
                          <p className="font-mono text-[10px] text-logi-text0">{m.id}</p>
                        </div>
                      </div>
                    </td>
                    <td className="px-3 py-2.5 font-mono text-[11px] text-logi-muted">
                      <p>{m.chassisNo || '—'}</p>
                      <p className="text-logi-text0">{m.engineNo || '—'}</p>
                    </td>
                    <td className="px-3 py-2.5">
                      <div className="flex items-center gap-1">
                        <ExpiryBadge dateStr={m.mulkiyaExpiry} compact />
                        {mulkiyaAlert && <AlertTriangle className="h-3 w-3 text-red-700" />}
                      </div>
                    </td>
                    <td className="px-3 py-2.5"><ExpiryBadge dateStr={m.insuranceExpiry} compact /></td>
                    <td className="max-w-[140px] truncate px-3 py-2.5 font-mono text-[10px] text-logi-text0">{m.dashcamStreamUrl || '—'}</td>
                    <td className="px-3 py-2.5"><StatusBadge status={m.status} /></td>
                    <td className="px-3 py-2.5">
                      <button type="button" onClick={() => onEdit(m)} className="inline-flex items-center gap-1 rounded-lg border border-logi-grid px-2 py-1 text-[10px] font-bold uppercase text-logi-muted hover:border-logi-accent/40 hover:text-logi-accent">
                        <Pencil className="h-3 w-3" /> Edit
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
